import { RANGE_FILTERS } from '@core/Services/Search/Filters.constants';
import type { DropdownOptionProps } from '@gds/Dropdown/Components/DropdownOption.types';
import type { PriceTypeAtom } from '@search-filters/Atom/PriceTypeAtom';

export const PRICE_OPTIONS: Record<PriceTypeAtom, DropdownOptionProps[]> = {
  price: RANGE_FILTERS.price.map(v => ({
    label: `£${Number(v).toLocaleString('en-GB')}`,
    value: v,
  })),
  'monthly-price': RANGE_FILTERS.monthly_price.map(v => ({
    label: `£${Number(v).toLocaleString('en-GB')}`,
    value: v,
  })),
};

// monthly-price__lte must be a query param — /under-{x} on the `used` root
// maps back to price__lte, not monthly-price__lte (see GetFilterFromSlugItem.ts)
export const applySearchFilterToUrl = (
  base: string,
  priceFilterType: PriceTypeAtom | undefined,
  maxPrice: string,
): string => {
  if (!priceFilterType || !maxPrice || maxPrice === 'any_price') return base;

  const qIndex = base.indexOf('?');
  const path = qIndex === -1 ? base : base.slice(0, qIndex);
  const queryStr = qIndex === -1 ? '' : base.slice(qIndex + 1);

  if (priceFilterType === 'price') {
    const withPrice = `${path.replace(/\/under-[^/]*/g, '')}/under-${encodeURIComponent(maxPrice)}`;
    return queryStr ? `${withPrice}?${queryStr}` : withPrice;
  }

  const params = new URLSearchParams(queryStr);
  params.set('monthly-price__lte', maxPrice);
  return `${path}?${params.toString()}`;
};
